<template>
    <div>
      <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row flex-grow">
            <div class="col-lg-4 mx-auto">
              <div class="auth-form-light text-center p-5">
                <div class="brand-logo justify-content-center">
                  <img src="/assets/img/admin.png">
                </div>
                <h2>Forget password</h2>
                <!-- <h6 class="font-weight-light">Sign in to continue.</h6> -->
                <form class="pt-3" v-on:submit.prevent="login()">
                  <div class="form-group">
                    <input type="email" v-model="message.email" class="form-control" id="exampleInputEmail1" placeholder="Email">
                  </div>

                  <div class="mt-3 justify-content-center">
                    <button type="submit" class="btn btn-block btn-success btn-lg font-weight-medium auth-form-btn">Get OTP</button>
                  </div>
                  <div class="my-2 d-flex justify-content-between align-items-center">
                    <div class="form-check">
                      <label class="form-check-label text-muted">
                        <input type="checkbox" class="form-check-input"> Keep me signed in </label>
                    </div>
                    <router-link to="/" href="#" class="auth-link text-black">Login?</router-link>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
    </div>
</template>
<script>
export default {
    name: 'App',
    components: {
    },
    data(){
        return {
            message:{},
        }
    },
    created() {


    },
    methods: {
        login(){
        
        },

    }
}
</script>
